import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react'

const Sortable = (accessorKey) => {
    const navigate = useNavigate()
    const data = accessorKey
    const location = useLocation()
    const [field, setField] = useState()
    const [sort, setSort] = useState()
    const sortRecord = (sort, field) => {
        let path = window.location.pathname
       
        // const searchParams = new URLSearchParams(location.search)
        // const params = {}
        // searchParams.forEach((value, key) => (params[key] = value))
        // const key = Object.keys(params)[0]
        // const value = params[key]
        setField(() => field)
        setSort(() => sort)
    }
   

    useEffect(()=>{
        let path = window.location.pathname
        navigate(`${path}?${field}=${sort}`)
    },[sort,field])

    const chevronUpStyle = {
        color: sort === 'asc' ? 'green' : 'gray',
        cursor: 'pointer',
    }

    const chevronDownStyle = {
        color: sort === 'dsc' ? 'green' : 'gray',
        marginTop: '-5px',
        cursor: 'pointer',
    }
    return (
        <>
            <span onClick={() => sortRecord('asc', accessorKey['accessorKey'])} style={chevronUpStyle}>
                <ChevronUp size={16} strokeWidth={3} />
            </span>
            <span onClick={() => sortRecord('dsc', accessorKey['accessorKey'])} style={chevronDownStyle}>
                <ChevronDown size={16} className="mt-[-5px]" strokeWidth={3} />
            </span>
        </>
    )
}

export default Sortable
